"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import * as _utils from "./utils";
import _styles from "./EngineEarsFooter2024.module.css";

const _interactionsData = JSON.parse(
  '{"events":{"e-592":{"id":"e-592","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-233","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-593"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b8c88566-0cc6-0717-7bc1-dcfe6592d7db","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b8c88566-0cc6-0717-7bc1-dcfe6592d7db","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1705356596046},"e-600":{"id":"e-600","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-234","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-601"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".waves---expandable-item-3","originalId":"62d6c03a6672f738121c205d|4f7015af-b754-4c2e-f5d8-1e5018ee5cf6","appliesTo":"CLASS"},"targets":[{"selector":".waves---expandable-item-3","originalId":"62d6c03a6672f738121c205d|4f7015af-b754-4c2e-f5d8-1e5018ee5cf6","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1658243815639},"e-601":{"id":"e-601","name":"","animationType":"custom","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-235","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-600"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".waves---expandable-item-3","originalId":"62d6c03a6672f738121c205d|4f7015af-b754-4c2e-f5d8-1e5018ee5cf6","appliesTo":"CLASS"},"targets":[{"selector":".waves---expandable-item-3","originalId":"62d6c03a6672f738121c205d|4f7015af-b754-4c2e-f5d8-1e5018ee5cf6","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1658243815641},"e-602":{"id":"e-602","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-236","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-603"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"a947936a-c3d3-9132-229a-321cc07fd022","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"a947936a-c3d3-9132-229a-321cc07fd022","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1705360271218}},"actionLists":{"a-233":{"id":"a-233","title":"carrot highlight","actionItemGroups":[{"actionItems":[{"id":"a-233-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"SIBLINGS","selector":".submit-button-8","selectorGuids":["d1151eef-5ed3-02fb-6af6-508f3667d165"]},"value":"none"}}]},{"actionItems":[{"id":"a-233-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".submit-button-8.newsletter-alt","selectorGuids":["d1151eef-5ed3-02fb-6af6-508f3667d165","5e78805e-29f3-69bb-5e06-199575f196e1"]},"value":"block"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1705355957622},"a-234":{"id":"a-234","title":"WAVES / Expand 2","actionItemGroups":[{"actionItems":[{"id":"a-234-n","actionTypeId":"STYLE_SIZE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".waves---expandable-open-3","selectorGuids":["f8effb15-d64a-5b43-225e-302a1f38a5b0"]},"heightValue":0,"widthUnit":"PX","heightUnit":"px","locked":false}},{"id":"a-234-n-2","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".waves---expand-icon-wrap-3","selectorGuids":["f8effb15-d64a-5b43-225e-302a1f38a5ad"]},"zValue":0,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-234-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".waves---expandable-open-3","selectorGuids":["f8effb15-d64a-5b43-225e-302a1f38a5b0"]},"value":0,"unit":""}},{"id":"a-234-n-4","actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".waves---expandable-open-3","selectorGuids":["f8effb15-d64a-5b43-225e-302a1f38a5b0"]},"xValue":1,"yValue":0,"locked":false}}]},{"actionItems":[{"id":"a-234-n-5","actionTypeId":"STYLE_SIZE","config":{"delay":0,"easing":"easeOut","duration":300,"target":{"useEventTarget":"CHILDREN","selector":".waves---expandable-open-3","selectorGuids":["f8effb15-d64a-5b43-225e-302a1f38a5b0"]},"widthUnit":"PX","heightUnit":"AUTO","locked":false}},{"id":"a-234-n-6","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"easeOut","duration":300,"target":{"useEventTarget":"CHILDREN","selector":".waves---expand-icon-wrap-3","selectorGuids":["f8effb15-d64a-5b43-225e-302a1f38a5ad"]},"zValue":180,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-234-n-7","actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"easeOut","duration":300,"target":{"useEventTarget":"CHILDREN","selector":".waves---expandable-open-3","selectorGuids":["f8effb15-d64a-5b43-225e-302a1f38a5b0"]},"xValue":1,"yValue":1,"locked":true}},{"id":"a-234-n-8","actionTypeId":"STYLE_OPACITY","config":{"delay":200,"easing":"","duration":300,"target":{"useEventTarget":"CHILDREN","selector":".waves---expandable-open-3","selectorGuids":["f8effb15-d64a-5b43-225e-302a1f38a5b0"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1658242693387},"a-235":{"id":"a-235","title":"WAVES / Collapse 2","actionItemGroups":[{"actionItems":[{"id":"a-235-n","actionTypeId":"STYLE_SIZE","config":{"delay":0,"easing":"ease","duration":300,"target":{"useEventTarget":"CHILDREN","selector":".waves---expandable-open-3","selectorGuids":["f8effb15-d64a-5b43-225e-302a1f38a5b0"]},"heightValue":0,"widthUnit":"PX","heightUnit":"px","locked":false}},{"id":"a-235-n-2","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"ease","duration":300,"target":{"useEventTarget":"CHILDREN","selector":".waves---expand-icon-wrap-3","selectorGuids":["f8effb15-d64a-5b43-225e-302a1f38a5ad"]},"zValue":0,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-235-n-3","actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"ease","duration":400,"target":{"useEventTarget":"CHILDREN","selector":".waves---expandable-open-3","selectorGuids":["f8effb15-d64a-5b43-225e-302a1f38a5b0"]},"yValue":0,"locked":false}},{"id":"a-235-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".waves---expandable-open-3","selectorGuids":["f8effb15-d64a-5b43-225e-302a1f38a5b0"]},"value":0,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1658242693387},"a-236":{"id":"a-236","title":"New Timed Animation","actionItemGroups":[],"useFirstGroupAsInitialState":false,"createdOn":1705360281804}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function EngineEarsFooter2024({ as: _Component = _Builtin.Section }) {
  _interactions.useInteractions(_interactionsData, _styles);

  return (
    <_Component
      className={_utils.cx(_styles, "engineears-footer")}
      grid={{
        type: "section",
      }}
      tag="div"
      wfr-c="WebflowFooter"
    >
      <_Builtin.Block
        className={_utils.cx(_styles, "waves-top-footer-2")}
        tag="div"
      >
        <_Builtin.Block
          className={_utils.cx(_styles, "waves-top-left-footer-2")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "waves-column-links-footer-2")}
            tag="div"
          >
            <_Builtin.Heading
              className={_utils.cx(_styles, "footer-h3")}
              tag="h3"
            >
              {"Resources"}
            </_Builtin.Heading>
            <_Builtin.Block
              className={_utils.cx(_styles, "waves-links-wrap-footer-2")}
              tag="div"
            >
              <_Builtin.Link
                className={_utils.cx(_styles, "waves-link-footer-2")}
                button={false}
                block=""
                options={{
                  href: "http://engineears.com/for-artists",
                }}
              >
                {"For Artists"}
              </_Builtin.Link>
              <_Builtin.Link
                className={_utils.cx(_styles, "waves-link-footer-2")}
                button={false}
                block=""
                options={{
                  href: "http://engineears.com/for-engineers",
                }}
              >
                {"For Audio Engineers"}
              </_Builtin.Link>
              <_Builtin.Link
                className={_utils.cx(_styles, "waves-link-footer-2")}
                button={false}
                block=""
                options={{
                  href: "http://engineears.com/for-studios",
                }}
              >
                {"For Studios"}
              </_Builtin.Link>
              <_Builtin.Link
                className={_utils.cx(_styles, "waves-link-footer-2")}
                button={false}
                block=""
                options={{
                  href: "http://engineears.com/for-labels",
                }}
              >
                {"For Record Labels"}
              </_Builtin.Link>
              <_Builtin.Link
                className={_utils.cx(_styles, "waves-link-footer-2")}
                button={false}
                block=""
                options={{
                  href: "http://community.engineears.com/case-studies",
                }}
              >
                {"Case Studies"}
              </_Builtin.Link>
              <_Builtin.Link
                className={_utils.cx(_styles, "waves-link-footer-2")}
                button={false}
                block=""
                options={{
                  href: "http://engineears.com/findmyengineer",
                }}
              >
                {"Find My Audio Engineer"}
              </_Builtin.Link>
              <_Builtin.Link
                className={_utils.cx(_styles, "waves-link-footer-2")}
                button={false}
                block=""
                options={{
                  href: "https://support.engineears.com/en/knowledge-base/glossary-of-terms",
                  target: "_blank",
                }}
              >
                {"Audio Engineering Glossary"}
              </_Builtin.Link>
              <_Builtin.Link
                className={_utils.cx(_styles, "waves-link-footer-2")}
                button={false}
                block=""
                options={{
                  href: "http://engineears.com/paginated-studios",
                }}
              >
                {"Recording Studios Near Me"}
              </_Builtin.Link>
              <_Builtin.Link
                className={_utils.cx(_styles, "waves-link-footer-2")}
                button={false}
                block=""
                options={{
                  href: "http://engineears.com/dolbyatmos",
                }}
              >
                {"dolby atmos certification"}
              </_Builtin.Link>
            </_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "waves-column-links-footer-2")}
            tag="div"
          >
            <_Builtin.Heading
              className={_utils.cx(_styles, "footer-h3")}
              tag="h3"
            >
              {"Information"}
            </_Builtin.Heading>
            <_Builtin.Block
              className={_utils.cx(_styles, "waves-links-wrap-footer-2")}
              tag="div"
            >
              <_Builtin.Link
                className={_utils.cx(
                  _styles,
                  "waves-link-footer-2",
                  "disabled"
                )}
                button={false}
                block=""
                options={{
                  href: "#",
                }}
              >
                {"About"}
              </_Builtin.Link>
              <_Builtin.Link
                className={_utils.cx(_styles, "waves-link-footer-2")}
                button={false}
                block=""
                options={{
                  href: "https://support.engineears.com/en/knowledge-base",
                  target: "_blank",
                  preload: "none",
                }}
              >
                {"Help Center"}
              </_Builtin.Link>
              <_Builtin.Link
                className={_utils.cx(_styles, "waves-link-footer-2")}
                button={false}
                block=""
                options={{
                  href: "https://engineears.com/add-subscription",
                  target: "_blank",
                  preload: "none",
                }}
              >
                {"Pricing"}
              </_Builtin.Link>
              <_Builtin.Link
                className={_utils.cx(_styles, "waves-link-footer-2")}
                button={false}
                block=""
                options={{
                  href: "https://members.engineears.com/platform-features",
                }}
              >
                {"Features"}
              </_Builtin.Link>
              <_Builtin.Link
                className={_utils.cx(_styles, "waves-link-footer-2")}
                button={false}
                block=""
                options={{
                  href: "https://blog.engineears.com/",
                }}
              >
                {"Blog"}
              </_Builtin.Link>
              <_Builtin.Link
                className={_utils.cx(_styles, "waves-link-footer-2")}
                button={false}
                block=""
                options={{
                  href: "https://members.engineears.com",
                  target: "_blank",
                }}
              >
                {"Community"}
              </_Builtin.Link>
              <_Builtin.Link
                className={_utils.cx(_styles, "waves-link-footer-2")}
                button={false}
                block=""
                options={{
                  href: "http://sounddealer.com",
                }}
              >
                {"Merch"}
              </_Builtin.Link>
              <_Builtin.Link
                className={_utils.cx(_styles, "waves-link-footer-2")}
                button={false}
                block=""
                options={{
                  href: "https://app.dover.io/EngineEars/careers/f0b0dced-bfc1-4d97-8e62-387773d1ef10",
                  target: "_blank",
                }}
              >
                {"Careers"}
              </_Builtin.Link>
              <_Builtin.Link
                className={_utils.cx(_styles, "waves-link-footer-2")}
                button={false}
                block=""
                options={{
                  href: "mailto:support@engineears.com",
                }}
              >
                {"Contact"}
              </_Builtin.Link>
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
        <_Builtin.Block
          className={_utils.cx(_styles, "waves-top-right-footer-2")}
          tag="div"
        >
          <_Builtin.FormWrapper className={_utils.cx(_styles, "form-block-6")}>
            <_Builtin.FormForm
              className={_utils.cx(_styles, "newsletter-signup")}
              data-w-id="b8c88566-0cc6-0717-7bc1-dcfe6592d7d5"
              name="wf-form-Newsletter-Signup"
              data-name="Newsletter Signup"
              method="get"
              data-webflow-hubspot-api-form-url="https://hubspotonwebflow.com/api/forms/097502f4-3f81-47d0-8938-1c5ab00f107b"
              id="wf-form-Newsletter-Signup"
            >
              <_Builtin.FormBlockLabel
                className={_utils.cx(_styles, "waves---paragraph-big-8")}
              >
                {"Join Our Email List"}
              </_Builtin.FormBlockLabel>
              <_Builtin.VFlex
                className={_utils.cx(_styles, "flex-block-8")}
                data-w-id="18b4d6fb-c75f-ddd5-b130-ab2f91548b1b"
                tag="div"
              >
                <_Builtin.FormTextInput
                  className={_utils.cx(_styles, "text-field-8")}
                  data-w-id="b8c88566-0cc6-0717-7bc1-dcfe6592d7db"
                  name="email"
                  maxLength={256}
                  data-name="Email"
                  placeholder="Enter Email Address"
                  disabled={false}
                  type="email"
                  required={true}
                  autoFocus={false}
                  data-wfhsfieldname="FormTextInput-2"
                  id="email"
                />
                <_Builtin.FormButton
                  className={_utils.cx(
                    _styles,
                    "submit-button-8",
                    "newsletter-alt"
                  )}
                  type="submit"
                  value="   "
                  data-wait="Please wait..."
                />
                <_Builtin.FormButton
                  className={_utils.cx(_styles, "submit-button-8")}
                  type="submit"
                  value="   "
                  data-wait="Please wait..."
                />
              </_Builtin.VFlex>
              <_Builtin.NotSupported _atom="DOM" />
              <_Builtin.NotSupported _atom="DOM" />
              <_Builtin.NotSupported _atom="DOM" />
              <_Builtin.NotSupported _atom="DOM" />
              <_Builtin.NotSupported _atom="DOM" />
            </_Builtin.FormForm>
            <_Builtin.FormSuccessMessage
              className={_utils.cx(_styles, "", "success-message")}
            >
              <_Builtin.Block tag="div">
                {"Thank you! Your submission has been received!"}
              </_Builtin.Block>
            </_Builtin.FormSuccessMessage>
            <_Builtin.FormErrorMessage
              className={_utils.cx(_styles, "error-message")}
            >
              <_Builtin.Block tag="div">
                {"Oops! Something went wrong while submitting the form."}
              </_Builtin.Block>
            </_Builtin.FormErrorMessage>
          </_Builtin.FormWrapper>
        </_Builtin.Block>
        <_Builtin.HFlex
          className={_utils.cx(_styles, "flex-block-9", "alt")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "waves---paragraph-small-3")}
            tag="div"
          >
            {"Stay in the loop."}
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "waves-bottom-right-footer-2")}
            tag="div"
          >
            <_Builtin.Link
              button={false}
              block="inline"
              options={{
                href: "http://facebook.com/engineears",
                target: "_blank",
              }}
            >
              <_Builtin.Image
                className={_utils.cx(_styles, "waves-icon-24")}
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/659b7786f0e2bb267b2615b5_Facebook%20Icon.svg"
              />
            </_Builtin.Link>
            <_Builtin.Link
              button={false}
              block="inline"
              options={{
                href: "http://instagram.com/engineears",
                target: "_blank",
              }}
            >
              <_Builtin.Image
                className={_utils.cx(_styles, "waves-icon-24")}
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/659b7786e055ccf13e17189e_Instagram%20Icon.svg"
              />
            </_Builtin.Link>
            <_Builtin.Link
              button={false}
              block="inline"
              options={{
                href: "https://www.tiktok.com/@engineears",
                target: "_blank",
              }}
            >
              <_Builtin.Image
                className={_utils.cx(_styles, "waves-icon-24")}
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/659b7787ac96291317421b1d_Tiktok%20icon.svg"
              />
            </_Builtin.Link>
            <_Builtin.Link
              button={false}
              block="inline"
              options={{
                href: "http://x.com/engineears",
                target: "_blank",
              }}
            >
              <_Builtin.Image
                className={_utils.cx(_styles, "waves-icon-24")}
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/659b77861b3593da28c1909f_X-Twitter%20Icon.svg"
              />
            </_Builtin.Link>
          </_Builtin.Block>
        </_Builtin.HFlex>
        <_Builtin.Block
          className={_utils.cx(_styles, "waves-expandable-master-faq-3")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "waves---expandable-wrap-3")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "waves---expandable-item-3")}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "waves---expandable-content-3")}
                tag="div"
              >
                <_Builtin.Heading
                  className={_utils.cx(_styles, "footer-h3")}
                  tag="h3"
                >
                  {"Resources"}
                </_Builtin.Heading>
                <_Builtin.Block
                  className={_utils.cx(_styles, "waves---expandable-open-3")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "waves-links-wrap-footer-2")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "waves---expand-space-3")}
                      tag="div"
                    />
                    <_Builtin.Link
                      className={_utils.cx(_styles, "waves-link-footer-2")}
                      button={false}
                      block=""
                      options={{
                        href: "http://engineears.com/for-artists",
                      }}
                    >
                      {"For Artists"}
                    </_Builtin.Link>
                    <_Builtin.Link
                      className={_utils.cx(_styles, "waves-link-footer-2")}
                      button={false}
                      block=""
                      options={{
                        href: "http://engineears.com/for-engineers",
                      }}
                    >
                      {"For Audio Engineers"}
                    </_Builtin.Link>
                    <_Builtin.Link
                      className={_utils.cx(_styles, "waves-link-footer-2")}
                      button={false}
                      block=""
                      options={{
                        href: "http://engineears.com/for-studios",
                      }}
                    >
                      {"For Studios"}
                    </_Builtin.Link>
                    <_Builtin.Link
                      className={_utils.cx(_styles, "waves-link-footer-2")}
                      button={false}
                      block=""
                      options={{
                        href: "http://engineears.com/for-labels",
                      }}
                    >
                      {"For Record Labels"}
                    </_Builtin.Link>
                    <_Builtin.Link
                      className={_utils.cx(_styles, "waves-link-footer-2")}
                      button={false}
                      block=""
                      options={{
                        href: "http://community.engineears.com/case-studies",
                      }}
                    >
                      {"Case Studies"}
                    </_Builtin.Link>
                    <_Builtin.Link
                      className={_utils.cx(_styles, "waves-link-footer-2")}
                      button={false}
                      block=""
                      options={{
                        href: "http://engineears.com/findmyengineer",
                      }}
                    >
                      {"Find My Audio Engineer"}
                    </_Builtin.Link>
                    <_Builtin.Link
                      className={_utils.cx(_styles, "waves-link-footer-2")}
                      button={false}
                      block=""
                      options={{
                        href: "https://support.engineears.com/en/knowledge-base/glossary-of-terms",
                        target: "_blank",
                      }}
                    >
                      {"Audio Engineering Glossary"}
                    </_Builtin.Link>
                    <_Builtin.Link
                      className={_utils.cx(_styles, "waves-link-footer-2")}
                      button={false}
                      block=""
                      options={{
                        href: "http://engineears.com/paginated-studios",
                      }}
                    >
                      {"Recording Studios Near Me"}
                    </_Builtin.Link>
                    <_Builtin.Link
                      className={_utils.cx(_styles, "waves-link-footer-2")}
                      button={false}
                      block=""
                      options={{
                        href: "http://engineears.com/dolbyatmos",
                      }}
                    >
                      {"dolby atmos certification"}
                    </_Builtin.Link>
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "waves---expand-icon-wrap-3")}
                tag="div"
              />
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "waves---expandable-item-3")}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "waves---expandable-content-3")}
                tag="div"
              >
                <_Builtin.Heading
                  className={_utils.cx(_styles, "footer-h3")}
                  tag="h3"
                >
                  {"Information"}
                </_Builtin.Heading>
                <_Builtin.Block
                  className={_utils.cx(_styles, "waves---expandable-open-3")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "waves-links-wrap-footer-2")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "waves---expand-space-3")}
                      tag="div"
                    />
                    <_Builtin.Link
                      className={_utils.cx(
                        _styles,
                        "waves-link-footer-2",
                        "disabled"
                      )}
                      button={false}
                      block=""
                      options={{
                        href: "#",
                      }}
                    >
                      {"About"}
                    </_Builtin.Link>
                    <_Builtin.Link
                      className={_utils.cx(_styles, "waves-link-footer-2")}
                      button={false}
                      block=""
                      options={{
                        href: "https://support.engineears.com/en/knowledge-base",
                        target: "_blank",
                        preload: "none",
                      }}
                    >
                      {"Help Center"}
                    </_Builtin.Link>
                    <_Builtin.Link
                      className={_utils.cx(_styles, "waves-link-footer-2")}
                      button={false}
                      block=""
                      options={{
                        href: "https://engineears.com/add-subscription",
                        target: "_blank",
                        preload: "none",
                      }}
                    >
                      {"Pricing"}
                    </_Builtin.Link>
                    <_Builtin.Link
                      className={_utils.cx(_styles, "waves-link-footer-2")}
                      button={false}
                      block=""
                      options={{
                        href: "https://members.engineears.com/platform-features",
                      }}
                    >
                      {"Features"}
                    </_Builtin.Link>
                    <_Builtin.Link
                      className={_utils.cx(_styles, "waves-link-footer-2")}
                      button={false}
                      block=""
                      options={{
                        href: "https://blog.engineears.com/",
                      }}
                    >
                      {"Blog"}
                    </_Builtin.Link>
                    <_Builtin.Link
                      className={_utils.cx(_styles, "waves-link-footer-2")}
                      button={false}
                      block=""
                      options={{
                        href: "https://members.engineears.com",
                        target: "_blank",
                      }}
                    >
                      {"Community"}
                    </_Builtin.Link>
                    <_Builtin.Link
                      className={_utils.cx(_styles, "waves-link-footer-2")}
                      button={false}
                      block=""
                      options={{
                        href: "http://sounddealer.com",
                      }}
                    >
                      {"Merch"}
                    </_Builtin.Link>
                    <_Builtin.Link
                      className={_utils.cx(_styles, "waves-link-footer-2")}
                      button={false}
                      block=""
                      options={{
                        href: "https://app.dover.io/EngineEars/careers/f0b0dced-bfc1-4d97-8e62-387773d1ef10",
                        target: "_blank",
                      }}
                    >
                      {"Careers"}
                    </_Builtin.Link>
                    <_Builtin.Link
                      className={_utils.cx(_styles, "waves-link-footer-2")}
                      button={false}
                      block=""
                      options={{
                        href: "mailto:support@engineears.com",
                      }}
                    >
                      {"Contact"}
                    </_Builtin.Link>
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "waves---expand-icon-wrap-3")}
                tag="div"
              />
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
      <_Builtin.Block
        className={_utils.cx(_styles, "waves-bottom-footer-2")}
        tag="div"
      >
        <_Builtin.HFlex
          className={_utils.cx(_styles, "flex-block-9")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "waves---paragraph-small-3")}
            tag="div"
          >
            {"Stay in the loop."}
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "waves-bottom-right-footer-2")}
            tag="div"
          >
            <_Builtin.Link
              button={false}
              block="inline"
              options={{
                href: "http://facebook.com/engineears",
                target: "_blank",
              }}
            >
              <_Builtin.Image
                className={_utils.cx(_styles, "waves-icon-24")}
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/659b7786f0e2bb267b2615b5_Facebook%20Icon.svg"
              />
            </_Builtin.Link>
            <_Builtin.Link
              button={false}
              block="inline"
              options={{
                href: "http://instagram.com/engineears",
                target: "_blank",
              }}
            >
              <_Builtin.Image
                className={_utils.cx(_styles, "waves-icon-24")}
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/659b7786e055ccf13e17189e_Instagram%20Icon.svg"
              />
            </_Builtin.Link>
            <_Builtin.Link
              button={false}
              block="inline"
              options={{
                href: "https://www.tiktok.com/@engineears",
                target: "_blank",
              }}
            >
              <_Builtin.Image
                className={_utils.cx(_styles, "waves-icon-24")}
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/659b7787ac96291317421b1d_Tiktok%20icon.svg"
              />
            </_Builtin.Link>
            <_Builtin.Link
              button={false}
              block="inline"
              options={{
                href: "http://x.com/engineears",
                target: "_blank",
              }}
            >
              <_Builtin.Image
                className={_utils.cx(_styles, "waves-icon-24")}
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/659b77861b3593da28c1909f_X-Twitter%20Icon.svg"
              />
            </_Builtin.Link>
          </_Builtin.Block>
        </_Builtin.HFlex>
        <_Builtin.HFlex
          className={_utils.cx(_styles, "flex-block-10")}
          tag="div"
        >
          <_Builtin.Link
            className={_utils.cx(_styles, "link-block-19")}
            button={false}
            block="inline"
            options={{
              href: "http://engineears.com",
              target: "_blank",
              preload: "none",
            }}
          >
            <_Builtin.Image
              className={_utils.cx(_styles, "image-75")}
              loading="lazy"
              width="auto"
              height="auto"
              alt=""
              src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/659b7e24dfa99d9cee7dc9e8_EngineEars-Tall-Logo.svg"
            />
          </_Builtin.Link>
          <_Builtin.VFlex
            className={_utils.cx(_styles, "flex-block-11")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "text-block-34")}
              tag="div"
            >
              {"© 2025 "}
              <_Builtin.Link
                className={_utils.cx(_styles, "link-7")}
                button={false}
                block=""
                options={{
                  href: "#",
                  target: "_blank",
                }}
              >
                {"EngineEars, Inc."}
              </_Builtin.Link>
              {" All rights reserved."}
            </_Builtin.Block>
            <_Builtin.HFlex
              className={_utils.cx(_styles, "flex-block-12")}
              tag="div"
            >
              <_Builtin.Link
                className={_utils.cx(_styles, "link-6")}
                button={false}
                block=""
                options={{
                  href: "https://storage.googleapis.com/engineears-static/docs/EngineEarsTermsOfUse.pdf",
                  target: "_blank",
                }}
              >
                {"Terms of Use"}
              </_Builtin.Link>
              <_Builtin.Block
                className={_utils.cx(_styles, "text-block-33")}
                tag="div"
              >
                {"|"}
              </_Builtin.Block>
              <_Builtin.Link
                className={_utils.cx(_styles, "link-6")}
                button={false}
                block=""
                options={{
                  href: "https://storage.googleapis.com/engineears-static/docs/EngineEarsPrivacyPolicy.pdf",
                  target: "_blank",
                }}
              >
                {"Privacy Policy"}
              </_Builtin.Link>
            </_Builtin.HFlex>
          </_Builtin.VFlex>
        </_Builtin.HFlex>
      </_Builtin.Block>
    </_Component>
  );
}
